export default function CompanyInfo() {
  return (
    <section id="chi-siamo" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-orange-500 font-serif italic text-lg mb-4">
            La Nostra Storia
          </p>
          <h2 className="text-5xl md:text-6xl font-black text-gray-900 mb-4 leading-tight">
            Innovazione
            <span className="block italic font-serif text-orange-500">
              e Affidabilità
            </span>
            <span className="block">dal 2018</span>
          </h2>
          <p className="text-xl text-gray-600 mt-6 font-medium">
            Word Art S.r.l.s - Nocera Superiore (SA)
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-20">
          <div className="bg-gradient-to-br from-orange-500 to-orange-600 rounded-3xl p-12 text-white relative overflow-hidden shadow-2xl hover:shadow-orange-500/50 transition-all duration-300 hover:-translate-y-2">
            <div className="absolute top-8 right-8">
              <div className="w-12 h-12 flex items-center justify-center bg-white rounded-full cursor-pointer hover:scale-110 transition-transform">
                <i className="ri-arrow-right-up-line text-2xl text-orange-500"></i>
              </div>
            </div>
            <div className="relative z-10">
              <div className="text-8xl font-serif font-black mb-4">5000+</div>
              <p className="text-2xl font-bold mb-2">Prodotti Disponibili</p>
              <p className="text-xl text-orange-100">In Pronta Consegna</p>
              <p className="mt-8 text-lg italic font-light">
                &quot;Qualità e velocità per il tuo business&quot;
              </p>
            </div>
          </div>

          <div className="bg-gradient-to-br from-indigo-100 to-purple-100 rounded-3xl p-12 text-gray-900 relative overflow-hidden shadow-2xl hover:shadow-purple-500/30 transition-all duration-300 hover:-translate-y-2">
            <div className="absolute top-8 right-8">
              <div className="w-12 h-12 flex items-center justify-center bg-gray-900 rounded-full cursor-pointer hover:scale-110 transition-transform">
                <i className="ri-arrow-right-up-line text-2xl text-white"></i>
              </div>
            </div>
            <div className="relative z-10">
              <div className="text-8xl font-serif font-black mb-4">24/48h</div>
              <p className="text-2xl font-bold mb-2">Tempi di Consegna</p>
              <p className="text-xl text-gray-700">Garantiti su Territorio Nazionale</p>
              <p className="mt-8 text-lg italic font-light text-gray-700">
                &quot;Spedizioni rapide e affidabili&quot;
              </p>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-3xl p-12 shadow-xl">
          <div className="max-w-4xl mx-auto">
            <h3 className="text-3xl font-bold text-gray-900 mb-6">Chi Siamo</h3>
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              Word Art S.r.l.s è un&apos;azienda specializzata nella distribuzione
              all&apos;ingrosso di prodotti tecnologici e soluzioni innovative per
              professionisti e rivenditori. Con sede a Nocera Superiore, nel cuore
              della Campania, offriamo un servizio completo e personalizzato per
              soddisfare ogni esigenza del settore B2B.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              La nostra missione è fornire prodotti di alta qualità, prezzi
              competitivi e un supporto dedicato per aiutare i nostri partner a
              crescere e prosperare nel mercato tecnologico in continua evoluzione.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
